import { langDisclaimer } from "../../../NewConstants/ChatConstants";

const LangDisclaimer = ({ selectedLanguage }) => {
  return (
    <div className='w-[65vw] rounded-md border border-[var(--disclaimer-2)] bg-[var(--disclaimer-3)] p-3'>
      <div className='text-[var(--disclaimer-1)] text-sm font-normal leading-4'>
        <span className='inline-flex items-start justify-center text-center'>
        <img src={"/Assets/Images/lang_disclaimer_icon.svg"} alt='lock'/>
          {langDisclaimer[selectedLanguage]}
        </span>
      </div>
    </div>
  )
}

export default LangDisclaimer